import React, { FC, RefObject } from 'react'

import { ArrowLeftIcon, ArrowRightIcon, IconWeight } from '@inno-ui/icons'
import clsx from 'clsx'
import { motion } from 'motion/react'

import { StepDots } from '../StepDots/StepDots'
import styles from './TourNav.module.scss'

export interface TourNavProps {
  activeIndex: number
  ariaLabel: string
  backLabel?: string
  nextLabel: string
  nextButtonRef?: RefObject<HTMLButtonElement>
  onBack?: () => void
  onNext: () => void
  showBack: boolean
  skipLabel: string
  total: number
  onSkip: () => void
}

export const TourNav: FC<TourNavProps> = ({
  activeIndex,
  ariaLabel,
  backLabel,
  nextLabel,
  nextButtonRef,
  onBack,
  onNext,
  showBack,
  skipLabel,
  total,
  onSkip
}) => {
  return (
    <div className={styles.navigation}>
      <button
        type='button'
        className={clsx(styles.button, styles.textButton)}
        onClick={onSkip}
      >
        {skipLabel}
      </button>

      <StepDots
        activeIndex={activeIndex}
        ariaLabel={ariaLabel}
        className={styles.stepDots}
        total={total}
      />

      <div className={styles.navigationActions}>
        {showBack && (
          <button
            type='button'
            className={clsx(styles.button, styles.textButton)}
            onClick={onBack}
          >
            <ArrowLeftIcon
              aria-hidden='true'
              color='var(--white)'
              weight={IconWeight.Bold}
            />
            {backLabel}
          </button>
        )}
        <button
          ref={nextButtonRef}
          type='button'
          className={clsx(styles.button, styles.primaryButton)}
          onClick={onNext}
        >
          {nextLabel}
          <ArrowRightIcon
            aria-hidden='true'
            color='var(--primary-blue-light)'
            weight={IconWeight.Bold}
          />
        </button>
      </div>
    </div>
  )
}

export const MotionTourNav: FC<TourNavProps> = props => {
  return (
    <motion.div
      className={styles.navigation}
      layout
      transition={{
        layout: { duration: 0.28, ease: 'easeInOut' }
      }}
    >
      <motion.button
        layout
        className={clsx(styles.button, styles.textButton)}
        onClick={props.onSkip}
        transition={{
          layout: { duration: 0.28, ease: 'easeInOut' }
        }}
      >
        {props.skipLabel}
      </motion.button>
      <StepDots
        activeIndex={props.activeIndex}
        ariaLabel={props.ariaLabel}
        className={styles.stepDots}
        total={props.total}
      />
      <div className={styles.navigationActions}>
        {props.showBack && (
          <motion.button
            layout
            className={clsx(styles.button, styles.textButton)}
            onClick={props.onBack}
            transition={{
              layout: { duration: 0.28, ease: 'easeInOut' }
            }}
          >
            <ArrowLeftIcon weight={IconWeight.Bold} color='var(--white)' />
            {props.backLabel}
          </motion.button>
        )}
        <motion.button
          layout
          ref={props.nextButtonRef}
          className={clsx(styles.button, styles.primaryButton)}
          onClick={props.onNext}
          transition={{
            layout: { duration: 0.28, ease: 'easeInOut' }
          }}
        >
          {props.nextLabel}
          <ArrowRightIcon weight={IconWeight.Bold} />
        </motion.button>
      </div>
    </motion.div>
  )
}
